import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_ZONE_DEPENDENCIES } from './actionTypes';
import { getPlcSafetyZoneDependenciesSuccess, getPlcSafetyZoneDependenciesError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getZoneDependencies({ payload: { user } }) {
  try {
    const response = yield call(plcSafetyAPI.getZoneDependencies, user.token);
    yield put(getPlcSafetyZoneDependenciesSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyZoneDependenciesError(error));
  }
}

export function* watchGetPlcSafetyZoneDependencies() {
  yield takeEvery(GET_PLC_SAFETY_ZONE_DEPENDENCIES, getZoneDependencies);
}

function* getPlcSafetyZoneDependenciesSaga() {
  yield all([fork(watchGetPlcSafetyZoneDependencies)]);
}

export default getPlcSafetyZoneDependenciesSaga;
